<app-header></app-header>
<app-right-side></app-right-side>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="assets/img/loader.webp">
</div>
<div class="container" style="border: 3px double #f1f0f0; border-radius: 10px;">
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div *ngFor="let item of iffhspost2.data" style="text-align: center;">
                <div class="ui-block-title">
                    <h6 class="label-title" style="color: var(--text-color);; top: 0px; text-align: left;">
                        <img src="https://iffhs.com/assets/images/logo.png" style="width: 50px; top:10px;  position: relative;">
                        &nbsp;IFFHS.COM &nbsp;<i class="fad fa-long-arrow-alt-right"></i>&nbsp;<a href="https://iffhs.com/posts/{{item.id}}" style="color:#073e58">{{item.title}}</a></h6>
                </div>
                <br>
                <div class="listing-image"><img src="https://iffhs.com/storage/img/posts/{{item.image}}" style="width: 25%;"></div>
                <div style="font-size: 20px; padding-left: 15px; text-align: left; color:var(--text-color);">{{item.title}}</div>
                <div style="font-size: 15px; padding-left: 15px; text-align: left;"><i class="fad fa-calendar-alt"></i>&nbsp;{{item.created_at | date:'dd-MM-yyyy'}} | 
                    <i class="fad fa-tags" style="color:#e48b06"></i>&nbsp;<span style="color:#e48b06">{{item.name}}</span></div> 
                <hr  style="background-color: var(--text-color);">
                <div style="font-size: 15px; padding-left: 15px; text-align: left;"><div [innerHTML]="item.content"></div></div>
                <hr style="background-color: var(--text-color);">
                <div class="row">
                <div class="col-lg-4"><div class="numberheader" style="color: var(--text-color);;"><i class="fad fa-eye" style="color: #367dda; "></i>&nbsp; {{getformat(item.views)}} 
                    <span style="border-right:2px solid var(--text-color);; color:rgb(255, 255, 255)">&nbsp;</span>&nbsp;
                    <i class="fad fa-comments" style="color: #25912e;"></i>&nbsp;{{item.postcom}} 
                </div></div>
                <div class="col-lg-8">
                <ul class="post-meta" style="font-size: 17px; text-align: right;">
                    <li style="color: var(--text-color);;">Share Post: &nbsp;</li>
                    <li><a href="https://www.facebook.com/sharer/sharer.php?u=https://iffhs.com/posts/{{item.id}}" class="social-button " id=""><span class="fab fa-facebook" style="color:#1877f2"></span></a></li>
                    <li><a href="https://twitter.com/intent/tweet?text={{item.title}}&amp;url=https://iffhs.com/posts/{{item.id}}" class="social-button " id=""><span class="fab  fa-twitter" style="color:#000000"></span></a></li>
                    <li><a href="http://www.linkedin.com/shareArticle?mini=true&amp;url=https://iffhs.com/posts/{{item.id}}&amp;title={{item.title}}&amp;summary=dit is de linkedin summary" class="social-button " id=""><span class="fab  fa-linkedin" style="color:#0a66c2"></span></a></li>
                    <li><a href="https://wa.me/?text=https://iffhs.com/posts/{{item.id}}" class="social-button " id=""><span class="fab  fa-whatsapp" style="color:#25d366"></span></a></li>    
                </ul>
                </div>
            </div>
            <hr>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div clas="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 h4" style="color: var(--text-color);">
                    <i class="fad fa-comments" style="color: #25912e;"></i>&nbsp;Comments:  <br><br>
                </div>
                <form [formGroup]="commentForm" (ngSubmit)="setcommPost()">
                    <div *ngFor="let post of iffhspost2.data"><Label formControlName="Post_id" style="font-size: 10px; display: none;">{{post.id}}</Label></div>
                    <div class="row">
                    <div *ngFor="let user of userData" class="col-lg-1 col-1 post__author author vcard inline-items">
                        <img *ngIf="!user.avatar" src="assets/img/author-main1.webp" width="50" height="50" alt="author" class="mCS_img_loaded">
                        <img *ngIf="user.avatar" alt="author" [src]="user.avatar" class="img1">
                    </div>
                    <div class="col-lg-11 col-11">
                        <input type="text" formControlName="UserComment" name="UserComment1" value="" placeholder="Type what you are thinking here about this post .." style="font-size: 14px;">
                    </div>
                    <div class="add-options-message" style="font-size: 15px;">
                        <button type="submit" class="btn btn-primary"><i class="fad fa-paper-plane"></i>&nbsp;Send Comment</button>
                    </div></div>
                </form>
                <br>
                <hr>
                <div *ngIf="commentusers.length == 0" style="color: brown; padding-left: 25px;" class="h5">No comments on this post !!</div>
                <div *ngFor="let commentuser of commentusers" class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div class="row">
                    <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1"><i class="fad fa-user userlogo1"></i></div>
                    <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <div class="" style="color: var(--text-color);; font-size: 18px; font-weight: 600;">{{commentuser.UserName}} &nbsp;&nbsp; <span style="font-weight: normal; color: #8b8b8b; font-size: 16px;">{{calculateDiff(commentuser.created_at)}}</span></div>
                    <div class="" style=" font-size: 13px; color: var(--text-color);; font-weight: normal;">{{commentuser.UserComment}}</div>
                    <hr>
                    </div>
                    </div>
                    <br>
                </div>
                
            </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="height: 150px;"><br><br></div>
        
    </div>
</div>